import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'

const reportItems = [
  'The exact radio vendor and model',
  'Your operating system and NewChirp version',
  'The programming cable you are using',
  'A clear description of what happened and what you expected',
  'Any error messages, copied exactly',
]

export default function SupportPage() {
  return (
    <ContentPage
      eyebrow="// support"
      title="Get help & report issues"
      description="Something not working, or a radio you need supported? Here's how to get help fast and file a report that we can act on."
    >
      <Prose>
        <Section title="Before you report">
          <p>
            Many issues come down to the programming cable or its driver. Please check the{' '}
            <Link href="/faq" className="text-primary underline underline-offset-4">
              FAQ
            </Link>{' '}
            and confirm your cable appears as a serial port first. It solves the majority of
            &quot;radio not detected&quot; problems.
          </p>
        </Section>

        <Section title="What to include in a report">
          <p>Good reports get fixed faster. Please include:</p>
          <ul className="flex flex-col gap-2">
            {reportItems.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </Section>

        <Section title="Request a new radio">
          <p>
            NewChirp&apos;s model support grows all the time. If your radio is not yet supported,
            send us the details and, if possible, a memory image from the manufacturer&apos;s own
            software. That helps us add support much more quickly.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Reach the maintainer directly and we&apos;ll get back to you.
          </p>
          <a
            href="mailto:rick@newchirp.net"
            className="inline-flex w-fit items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
          >
            Email rick@newchirp.net
          </a>
        </Section>
      </Prose>
    </ContentPage>
  )
}
